



























































































import { fetchUsers, fetchJobApplications } from '@/utils/api'
import {
  debounce,
  getDaysFromNow,
  safeSubtract,
  translatedEnumOptions,
  translate,
  validationRules,
  convertToCsv,
  downloadFile,
  getAge,
  getDaysAndHoursBetweenDates,
  makeGqlRequest
} from '@/utils/helpers'
import { getJobListings } from '@/utils/queries'
import {
  Area,
  AreaOrderByInput,
  AreaWhereInput,
  Authority,
  AuthorityWhereInput,
  CrudDialogMode,
  CrudFieldType,
  CrudFormField,
  DataTableAction,
  FetchAreasPayload,
  FetchAuthoritiesPayload,
  FetchJobListingsPayload,
  Filter,
  FilterField,
  FilterType,
  JobListing,
  JobListingExpiration,
  JobListingsStatus,
  QueryParams,
  Role,
  SalaryType,
  TextValuePair,
  UpdateJobListingPayload,
  User,
  WeeklyWorkDays,
  FetchJobApplicationPayload,
  JobApplication,
  JobListingPlan,
  JobListingContactMethod,
  JobListingPlanConfiguration,
  ApprovalStatus,
  Branch
} from '@/utils/types'
import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { DataTableHeader } from 'vuetify'
import { Action, Getter } from 'vuex-class'
import CrudForm from '../components/CrudForm.vue'
import DataTable from '../components/DataTable.vue'
import JobListingDialog from '../components/JobListingDialog.vue'

@Component({
  components: { JobListingDialog, DataTable, CrudForm }
})
export default class JobListings extends Vue {
  @Action createJobListing!: (
    payload: UpdateJobListingPayload
  ) => Promise<boolean>;

  @Action fetchAreas!: (payload: FetchAreasPayload) => Promise<void>;
  @Action fetchAuthorities!: (
    payload: FetchAuthoritiesPayload
  ) => Promise<void>;

  @Action fetchJobListings!: (
    payload: FetchJobListingsPayload
  ) => Promise<void>;

  @Action updateJobListing!: (
    payload: UpdateJobListingPayload
  ) => Promise<boolean>;

  @Action fetchJobApplication!: (
    payload: FetchJobApplicationPayload
  ) => Promise<void>;

  @Action fetchJobListingPlanConfigurations!: () => Promise<void>;
  @Action fetchBranches!: () => Promise<void>;

  @Getter jobListingPlanConfigurations!: JobListingPlanConfiguration[]
  @Getter totalJobListings!: number;
  @Getter areas!: Area[];
  @Getter authorities!: Authority[];
  @Getter jobListings!: JobListing[];
  @Getter branches!: Branch[];
  @Getter jwt!: string;

  users: User[] = [];
  currentCrudDialogMode = CrudDialogMode.NONE;
  crudDialogMode = CrudDialogMode;
  dialogFields: CrudFormField<
    JobListing[keyof JobListing] | TextValuePair<string | number>
  >[] = [];

  itemsPerPage = 100;
  currentTab = 0;
  isLoading = false;
  jobListingsStatus: JobListingsStatus = JobListingsStatus.ACTIVE;
  orderBy = AreaOrderByInput.ID_DESC;
  isSnackbarVisible = false;
  snackbarMessage = '';
  isEmployerSearchLoading = false;
  searchTimeout = 0;

  defaultJobListing: JobListing = {
    airsAt: new Date(new Date().setHours(8, 0, 0, 0)),
    allowEmailNotifications: false,
    isAccessibleForTheDisabled: false,
    isBreaks: false,
    isInShifts: false,
    isOnSaturday: false,
    isOvertime: false,
    isPaidTraining: false,
    isPublicTransportationAccessible: false,
    isSalaryRaisable: false,
    isShuttles: false,
    isTips: false,
    isTravelsRefunded: false,
    isWorkFromHome: false,
    firstApplicationAt: null,
    totalApplications: 0,
    totalWhatsappApplications: 0,
    totalPhoneApplications: 0,
    uniqueApplications: 0,
    plan: '' as JobListingPlan,
    addresses: [],
    workplace: '',
    isAcceptingInAppApplications: false,
    contactMethods: []
  };

  currentJobListing: JobListing = this.defaultJobListing;
  jobListingHeaders: DataTableHeader[] = [
    { text: 'תפקיד', value: 'name', class: 'red lighten-5' },
    { text: 'מעסיק', value: 'ownerName', class: 'red lighten-5' },
    { text: 'בית העסק', value: 'workplace', class: 'red lighten-5' },
    {
      text: 'כמה עובדים צריך',
      value: 'unmannedJobsAmount',
      class: 'red lighten-5'
    },
    { text: 'גילאים', value: 'minimumAge', class: 'red lighten-5' },
    { text: 'שכר', value: 'hourlyRate', class: 'red lighten-5' },
    { text: 'כתובת', value: 'addresses', class: 'red lighten-5' },
    { text: 'מועד פרסום', value: 'airsAt', class: 'red lighten-5' },
    { text: 'שעת פרסום', value: 'airsAtTime', class: 'red lighten-5' },
    {
      text: 'ימים לירידת הפרסום',
      value: 'daysToExpiry',
      class: 'red lighten-5'
    },
    { text: 'רשות', value: 'activeAuthorityName', class: 'blue lighten-5' },
    { text: 'אזור', value: 'activeAreaName', class: 'blue lighten-5' },
    {
      text: 'פניה לראשונה',
      value: 'firstApplicationAt',
      class: 'red lighten-5'
    },
    { text: 'סה"כ פניות', value: 'totalApplications', class: 'red lighten-5' },
    {
      text: 'סה"כ פניות בוואטסאפ',
      value: 'totalWhatsappApplications',
      class: 'red lighten-5'
    },
    {
      text: 'סה"כ פניות בטלפון',
      value: 'totalPhoneApplications',
      class: 'red lighten-5'
    },
    {
      text: 'פניות ייחודיות',
      value: 'uniqueApplications',
      class: 'red lighten-5'
    },
    { text: 'הערות', value: 'notes', class: 'red lighten-5' },
    { text: 'מסלול פרסום', value: 'plan', class: 'blue lighten-5' }
  ];

  jobApplicationsByJobListingHeaders: DataTableHeader[] = [
    { text: 'שם פרטי', value: 'firstName' },
    { text: 'שם משפחה', value: 'lastName' },
    { text: 'טלפון', value: 'phone' },
    { text: 'גיל', value: 'age' },
    { text: 'תאריך הרשמה', value: 'userCreatedAt' },
    { text: 'אזור תעסוקה', value: 'area' },
    { text: 'רשות', value: 'authority' },
    {
      text: 'זמן מפרסום המשרה לפנייה',
      value: 'jobListingAgeAtApplication'
    },
    { text: 'סוג פנייה', value: 'type' },
    { text: 'תאריך', value: 'createdAtDate' },
    { text: 'שעה', value: 'createdAtTime' }
  ];

  @Watch('currentTab')
  async onCurrentTabChange () {
    await this.fetchPage(1)
  }

  @Watch('$route.query')
  async onQueryChange () {
    await this.fetchPage(1)
  }

  async mounted () {
    await this.fetchData()
    await this.fetchPage(1)
    await this.fetchJobListingPlanConfigurations()
  }

  async fetchData (): Promise<void> {
    if (!this.areas?.length) {
      this.isLoading = true
      await this.fetchAreas({
        orderBy: this.orderBy
      })
    }
    if (!this.authorities?.length) {
      this.isLoading = true
      await this.fetchAuthorities({
        isArchived: false,
        basic: true
      })
    }
    if (!this.branches?.length) {
      this.isLoading = true
      await this.fetchBranches()
    }
    this.isLoading = false
  }

  async fetchPage (page: number, searchText?: string): Promise<void> {
    this.setupJobListingsByTab()
    this.isLoading = true
    const fetchJobListingsPayload: FetchJobListingsPayload = this.buildFetchJobListingsPayload(
      page,
      searchText
    )

    await this.fetchJobListings(fetchJobListingsPayload)
    this.isLoading = false
  }

  private buildFetchJobListingsPayload (page: number, searchText: string|undefined) {
    const fetchJobListingsPayload: FetchJobListingsPayload = {
      page: page,
      limit: this.itemsPerPage,
      isBlocked: this.jobListingsStatus === JobListingsStatus.BLOCKED,
      plans: this.planFilter,
      area: this.closestAreaFilter,
      authority: this.authorityFilter,
      searchText: searchText,
      approvalStatus: ApprovalStatus.APPROVED
    }
    const today = new Date()

    switch (this.jobListingsStatus) {
      case JobListingsStatus.ACTIVE:
        fetchJobListingsPayload.expiresAtGTE = today
        fetchJobListingsPayload.airsAtLTE = today
        break

      case JobListingsStatus.PENDING:
        fetchJobListingsPayload.approvalStatus = ApprovalStatus.PENDING
        break

      case JobListingsStatus.UNAIRED:
        fetchJobListingsPayload.airsAtGT = today
        break

      case JobListingsStatus.EXPIRED:
        fetchJobListingsPayload.expiresAtLT = today
        break

      case JobListingsStatus.REPORTED:
        fetchJobListingsPayload.onlyReported = true
        break
    }
    return fetchJobListingsPayload
  }

  async toggleBlockingJobListing () {
    if (!this.currentJobListing.id) return
    await this.executeBlock(!this.currentJobListing.isBlocked)
    this.closeDialog()
  }

  onRowClick (jobListing: JobListing) {
    this.currentJobListing = jobListing
    this.currentCrudDialogMode = CrudDialogMode.VIEW
  }

  handleClearAllFilters () {
    this.$router.replace({
      path: this.$route.path
    })
  }

  handleStringFilters (filter: Filter<string>) {
    switch (filter.field) {
      case FilterField.areaIds:
        this.closestAreaFilter = {
          idIn: filter.subItems
            .filter((i) => i.isSelected)
            ?.map((i) => i.value)
        }
        break
      case FilterField.authorityIds:
        this.authorityFilter = {
          idIn: filter.subItems
            .filter((i) => i.isSelected)
            ?.map((i) => i.value)
        }
        break
      case FilterField.planTypes:
        this.planFilter = filter.subItems
          .filter((i) => i.isSelected)
          ?.map((i) => JobListingPlan[i.value])
        break
      default:
        break
    }
    this.fetchPage(1)
  }

  rateBySalaryType (salaryType?: SalaryType, hourlyRate?: number | string) {
    return salaryType === SalaryType.MINIMUM ? 'מינימום' : hourlyRate
  }

  closeDialog () {
    this.currentCrudDialogMode = CrudDialogMode.NONE
    this.dialogFields.length = 0
  }

  openDialog (mode: CrudDialogMode, item: JobListing = this.defaultJobListing) {
    this.dialogFields.length = 0
    this.currentJobListing =
      this.jobListings.find((j) => j.id === item.id) || item
    if (mode === CrudDialogMode.CREATE || mode === CrudDialogMode.EDIT) {
      this.setContactMethods()
      this.setJobsAmount()
      !!this.currentJobListing?.business?.owner &&
        this.users.push({
          ...this.currentJobListing.business?.owner,
          business: { id: this.currentJobListing.business?.id }
        })
      const expirationDates = translatedEnumOptions(JobListingExpiration)
      let daysToExpiration = 0
      if (this.currentJobListing.expiresAt) {
        daysToExpiration = Math.ceil(
          (this.currentJobListing.expiresAt.getTime() -
            this.currentJobListing.airsAt.getTime()) /
            (1000 * 3600 * 24)
        )
        expirationDates.unshift({
          text: `${daysToExpiration} ימים`,
          value: `${daysToExpiration}`
        })
      }
      this.dialogFields.push(
        {
          name: 'workplace',
          value: this.currentJobListing.workplace,
          label: 'שם מקום העבודה*',
          type: CrudFieldType.TEXT,
          rules: [validationRules.requiredValue]
        },
        {
          name: 'name',
          value: this.currentJobListing.name,
          label: 'תפקיד*',
          type: CrudFieldType.TEXT,
          rules: [validationRules.requiredValue]
        },
        {
          name: 'jobsAmount',
          value: this.currentJobListing.jobsAmount,
          label: 'כמה עובדים צריך*',
          type: CrudFieldType.SELECT,
          options: {
            items: [
              { text: '1 - 10', value: 5 },
              { text: '11 - 20', value: 15 },
              { text: '21 - 30', value: 25 },
              { text: '31+', value: 35 }
            ] as TextValuePair<number>[]
          },
          rules: [validationRules.requiredValue]
        },
        {
          name: 'business',
          value: this.currentJobListing.business?.id,
          label: 'מעסיק*',
          type: CrudFieldType.AUTOCOMPLETE_SELECT,
          options: {
            items: this.users,
            itemText: 'email',
            itemValue: 'business.id'
          },
          getLoading: () => this.isEmployerSearchLoading,
          searchFunc: this.searchEmployers,
          rules: [validationRules.requiredValue]
        },
        {
          name: 'branch',
          value: this.currentJobListing.branch?.id,
          label: 'ענף תעסוקתי*',
          type: CrudFieldType.SELECT,
          options: {
            items: this.branches,
            itemText: 'name',
            itemValue: 'id'
          },
          rules: [validationRules.requiredValue]
        },
        {
          name: 'divider',
          value: 'divider',
          label: '',
          type: CrudFieldType.DIVIDER,
          isLarge: true,
          isDisplayOnly: true
        },
        {
          name: 'airsAt',
          value: this.currentJobListing.airsAt,
          label: 'מועד פרסום משרה*',
          type: CrudFieldType.DATE,
          rules: [validationRules.requiredValue],
          min: new Date(
            Math.min(
              this.currentJobListing.airsAt.getTime(),
              new Date().getTime()
            )
          ),
          handleValueChanged: (value) => {
            if (!value) return
            const date = new Date(value as Date)
            date.setHours(this.currentJobListing.airsAt.getHours())
            date.setMinutes(this.currentJobListing.airsAt.getMinutes())
            this.currentJobListing.airsAt = date
            this.dialogFields[6].value = date
            this.dialogFields[7].value = date
          }
        },
        {
          name: 'airsAtTime',
          value: this.currentJobListing.airsAt,
          label: 'שעת פרסום משרה*',
          type: CrudFieldType.TIME,
          rules: [validationRules.requiredValue, validationRules.time],
          isDisplayOnly: true,
          handleValueChanged: (value) => {
            if (!value) return
            const date = new Date(value as Date)
            date.setFullYear(this.currentJobListing.airsAt.getFullYear())
            date.setMonth(this.currentJobListing.airsAt.getMonth())
            date.setDate(this.currentJobListing.airsAt.getDate())
            this.currentJobListing.airsAt = date
            this.dialogFields[6].value = date
            this.dialogFields[7].value = date
          }
        },
        {
          name: 'logoImage',
          value: this.currentJobListing.logoImage,
          label: 'לוגו',
          type: CrudFieldType.IMAGE
        },
        {
          name: 'image',
          value: this.currentJobListing.image,
          label: 'תמונה ראשית למודעה',
          type: CrudFieldType.IMAGE
        },
        {
          name: 'divider',
          value: 'divider',
          label: '',
          type: CrudFieldType.DIVIDER,
          isLarge: true,
          isDisplayOnly: true
        },
        {
          name: 'minimumAge',
          value: this.currentJobListing.minimumAge,
          label: 'גילאים*',
          type: CrudFieldType.SELECT,
          options: {
            items: [
              { text: '14+', value: 14 },
              { text: '15+', value: 15 },
              { text: '16+', value: 16 },
              { text: '17+', value: 17 },
              { text: '18+', value: 18 }
            ] as TextValuePair<number>[]
          },
          rules: [validationRules.requiredValue]
        },
        {
          name: 'salaryType',
          value: this.currentJobListing.salaryType,
          label: 'פרטי שכר*',
          type: CrudFieldType.SELECT,
          options: { items: translatedEnumOptions(SalaryType) },
          rules: [validationRules.requiredValue]
        },
        {
          name: 'hourlyRate',
          value: this.currentJobListing.hourlyRate || 30,
          label: 'שכר שעתי*',
          type: CrudFieldType.TEXT,
          isDisabled: this.getDisplayHourlyRate,
          rules: [validationRules.requiredValue]
        },
        {
          name: 'divider',
          value: '',
          label: '',
          type: CrudFieldType.DIVIDER,
          isLarge: true,
          isDisplayOnly: true
        },
        {
          name: 'startTime',
          value: this.currentJobListing.startTime,
          label: 'שעת תחילת עבודה',
          type: CrudFieldType.TIME
        },
        {
          name: 'endTime',
          value: this.currentJobListing.endTime,
          label: 'שעת סיום עבודה',
          type: CrudFieldType.TIME
        },
        {
          name: 'weeklyWorkDays',
          value: this.currentJobListing.weeklyWorkDays,
          label: 'היקף משרה*',
          type: CrudFieldType.MULTIPLE_SELECT,
          options: { items: translatedEnumOptions(WeeklyWorkDays) },
          rules: [validationRules.requiredArray]
        },
        {
          name: 'divider',
          value: '',
          label: '',
          type: CrudFieldType.DIVIDER,
          isLarge: true,
          isDisplayOnly: true
        },
        {
          name: 'requirements',
          value: this.currentJobListing.requirements,
          label: 'דרישות התפקיד',
          type: CrudFieldType.TEXT_AREA,
          isLarge: true
        },
        {
          name: 'description',
          value: this.currentJobListing.description,
          label: 'תיאור התפקיד',
          type: CrudFieldType.TEXT_AREA,
          isLarge: true
        },
        {
          name: 'work conditions',
          value: '',
          label: 'תנאי העסקה',
          type: CrudFieldType.DIVIDER,
          isLarge: true,
          isDisplayOnly: true
        },
        {
          name: 'isTips',
          value: this.currentJobListing.isTips,
          label: 'טיפים',
          type: CrudFieldType.SWITCH
        },
        {
          name: 'isOvertime',
          value: this.currentJobListing.isOvertime,
          label: 'שעות נוספות',
          type: CrudFieldType.SWITCH
        },
        {
          name: 'isSalaryRaisable',
          value: this.currentJobListing.isSalaryRaisable,
          label: 'אופציה להעלאת שכר',
          type: CrudFieldType.SWITCH
        },
        {
          name: 'isPaidTraining',
          value: this.currentJobListing.isPaidTraining,
          label: 'התלמדות בתשלום',
          type: CrudFieldType.SWITCH
        },
        {
          name: 'isBreaks',
          value: this.currentJobListing.isBreaks,
          label: 'הפסקות',
          type: CrudFieldType.SWITCH
        },
        {
          name: 'isPublicTransportationAccessible',
          value: this.currentJobListing.isPublicTransportationAccessible,
          label: 'גישה נוחה לתחבורה ציבורית',
          type: CrudFieldType.SWITCH
        },
        {
          name: 'isTravelsRefunded',
          value: this.currentJobListing.isTravelsRefunded,
          label: 'החזרי נסיעות',
          type: CrudFieldType.SWITCH
        },
        {
          name: 'isOnSaturday',
          value: this.currentJobListing.isOnSaturday,
          label: 'העבודה במהלך השבת',
          type: CrudFieldType.SWITCH
        },
        {
          name: 'isShuttles',
          value: this.currentJobListing.isShuttles,
          label: 'הסעות',
          type: CrudFieldType.SWITCH
        },
        {
          name: 'isAccessibleForTheDisabled',
          value: this.currentJobListing.isAccessibleForTheDisabled,
          label: 'נגישות לבעלי מוגבלויות',
          type: CrudFieldType.SWITCH
        },
        {
          name: 'notes',
          value: this.currentJobListing.notes,
          label: 'הערות',
          type: CrudFieldType.TEXT_AREA,
          isLarge: true
        },
        {
          name: 'plan',
          value: this.currentJobListing.plan,
          label: 'מסלול פרסום',
          type: CrudFieldType.SELECT,
          options: { items: translatedEnumOptions(JobListingPlan) },
          rules: [validationRules.requiredValue]
        },
        {
          name: 'phone',
          value: this.currentJobListing.phone,
          label: 'מספר ליצירת קשר בטלפון וב-whatsapp',
          type: CrudFieldType.TEXT,
          rules: [validationRules.phone],
          min: 9,
          max: 10
        },
        {
          name: 'contactMethods',
          value: this.currentJobListing.contactMethods,
          label: 'דרך ליצירת קשר',
          type: CrudFieldType.MULTIPLE_SELECT,
          options: { items: translatedEnumOptions(JobListingContactMethod) },
          rules: [validationRules.requiredArray, this.contactMethodsRules]
        },
        {
          name: 'addresses',
          value: this.currentJobListing.addresses,
          max: 10,
          label: 'כתובות',
          type: CrudFieldType.TEXT_ARRAY,
          isDisabled: () => {
            const len = this.currentJobListing.addresses?.length || 0
            if (!this.isPremium() && len > 0) return true
            return false
          },
          rules: [this.addressesRule]
        },
        {
          name: 'allowEmailNotifications',
          value: this.currentJobListing.allowEmailNotifications,
          max: 10,
          label: 'שליחת התראות במייל',
          type: CrudFieldType.SWITCH
        }
      )
    }
    this.currentCrudDialogMode = mode
  }

  async expirationDate (airsAtDate: Date, value: JobListingPlan): Promise<Date> {
    const newDate = new Date(airsAtDate)
    switch (value) {
      case JobListingPlan.BASIC:
        return new Date(newDate.setDate(newDate.getDate() + this.jobListingPlanConfigurations[0].publishDuration))
      case JobListingPlan.PRO:
        return new Date(newDate.setDate(newDate.getDate() + this.jobListingPlanConfigurations[1].publishDuration))
      case JobListingPlan.PREMIUM:
        return new Date(newDate.setDate(newDate.getDate() + this.jobListingPlanConfigurations[2].publishDuration))
    }
  }

  getDisplayHourlyRate (): boolean {
    return (
      (this.dialogFields.find((f) => f.name === 'salaryType')
        ?.value as SalaryType) === SalaryType.MINIMUM
    )
  }

  isPremium (): boolean {
    return (
      (this.dialogFields.find((f) => f.name === 'plan')
        ?.value as JobListingPlan) === JobListingPlan.PREMIUM
    )
  }

  contactMethodsRules (value: unknown): boolean | string {
    const contactMethods = value as JobListingContactMethod[]
    const phone = this.dialogFields.find((f) => f.name === 'phone')?.value as string

    if ((contactMethods.includes(JobListingContactMethod.PHONE_CALL) || contactMethods.includes(JobListingContactMethod.WHATSAPP_MSG)) && !phone) {
      return 'חסר מספר טלפון'
    }

    if (contactMethods.includes(JobListingContactMethod.JOB_APPLICATION) && !this.isPremium()) {
      return 'השדה "' + translate(JobListingContactMethod.JOB_APPLICATION) + '" מחייב פרימיום'
    }

    return true
  }

  handleContactMethods (jl) {
    if (jl.contactMethods.includes(JobListingContactMethod.WHATSAPP_MSG)) {
      jl.whatsapp = jl.phone
    }

    if (!jl.contactMethods.includes(JobListingContactMethod.PHONE_CALL)) {
      delete jl.phone
    }

    if (jl.contactMethods.includes(JobListingContactMethod.JOB_APPLICATION)) {
      jl.isAcceptingInAppApplications = true
    }

    delete jl.contactMethods
    return jl
  }

  async handleSubmit (eventData: CrudFormField[]) {
    let success = false
    let jobListing = _.zipObjectDeep(
      eventData.map((field) => field.name as keyof JobListing),
      eventData.map((field) => field.value)
    ) as JobListing

    jobListing = this.handleContactMethods(jobListing)
    jobListing.addresses = jobListing.addresses.filter(a => !!a)

    jobListing.expiresAt = await this.expirationDate(
      jobListing.airsAt,
      eventData.find((field) => field.name === 'plan')?.value as JobListingPlan
    )

    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.EDIT:
        success = await this.executeUpdate(jobListing)
        break
      case CrudDialogMode.ACTIVATE:
        success = await this.executeBlock(!this.currentJobListing.isBlocked)
        break
      case CrudDialogMode.CREATE:
        success = await this.executeCreate(jobListing)
        break
    }
    if (success) {
      this.snackbarMessage = 'הפעולה בוצעה בהצלחה'
      this.closeDialog()
      await this.fetchPage(1)
    } else {
      const isAddressError = sessionStorage.getItem('createJobListingError')?.includes('No location')
      this.snackbarMessage = isAddressError ? 'כתובת לא תקינה' : 'הפעולה נכשלה. אנא ודאו את הטופס'
    }
    this.isSnackbarVisible = true
  }

  async executeCreate (eventData: JobListing) {
    return this.createJobListing({ jobListing: eventData })
  }

  async executeUpdate (
    eventData: JobListing,
    id: string = this.currentJobListing.id || ''
  ) {
    return this.updateJobListing({ id: id, jobListing: eventData })
  }

  async executeBlock (
    isBlocked: boolean,
    id: string = this.currentJobListing.id || ''
  ) {
    return this.updateJobListing({
      id,
      isBlocking: true,
      jobListing: { isBlocked } as JobListing
    })
  }

  async searchJobListing (searchText: string) {
    await this.fetchPage(1, searchText)
  }

  setupJobListingsByTab () {
    switch (this.currentTab) {
      case 0:
        this.jobListingsStatus = JobListingsStatus.ACTIVE
        break
      case 1:
        this.jobListingsStatus = JobListingsStatus.PENDING
        break
      case 2:
        this.jobListingsStatus = JobListingsStatus.UNAIRED
        break
      case 3:
        this.jobListingsStatus = JobListingsStatus.EXPIRED
        break
      case 4:
        this.jobListingsStatus = JobListingsStatus.REPORTED
        break
      case 5:
        this.jobListingsStatus = JobListingsStatus.BLOCKED
        break
      default:
        return []
    }
  }

  get currentDialogTitle () {
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        return 'יצירת משרה חדשה'
      case CrudDialogMode.EDIT:
        return 'עריכת משרה'
      case CrudDialogMode.ACTIVATE:
        return 'את/ה בטוח/ה?'
    }
  }

  get closestAreaFilter (): AreaWhereInput | undefined {
    const query: QueryParams = this.$route.query
    return query.areaIds ? { idIn: query.areaIds?.split(',') } : undefined
  }

  set closestAreaFilter (area: AreaWhereInput | undefined) {
    const query = {
      ...this.$route.query,
      areaIds: area?.idIn?.join(',')
    }
    if (!area?.idIn?.length) {
      delete query.areaIds
    }
    this.$router.replace({
      path: this.$route.path,
      query: query
    })
  }

  get planFilter (): JobListingPlan[] | undefined {
    const query: QueryParams = this.$route.query
    return query?.plans?.split(',').map((p: string) => JobListingPlan[p])
  }

  set planFilter (planInput: JobListingPlan[] | undefined) {
    const query = {
      ...this.$route.query,
      plans: planInput?.join(',')
    }
    if (!planInput?.length) {
      delete query.plans
    }
    this.$router.replace({
      path: this.$route.path,
      query: query
    })
  }

  get authorityFilter (): AuthorityWhereInput | undefined {
    const query: QueryParams = this.$route.query
    return query.authorityIds
      ? { idIn: query.authorityIds?.split(',') }
      : undefined
  }

  set authorityFilter (authority: AuthorityWhereInput | undefined) {
    const query = {
      ...this.$route.query,
      authorityIds: authority?.idIn?.join(',')
    }
    if (!authority?.idIn?.length) {
      delete query.authorityIds
    }
    this.$router.replace({
      path: this.$route.path,
      query: query
    })
  }

  get jobListingActions (): DataTableAction<JobListing>[] {
    return [
      {
        text: 'עריכה',
        icon: 'mdi-pencil',
        handler: this.openDialog.bind(this, CrudDialogMode.EDIT)
      },
      {
        text:
          this.jobListingsStatus === JobListingsStatus.BLOCKED
            ? 'שחרור חסימה'
            : 'חסימה',
        icon: 'mdi-cancel',
        handler: this.openDialog.bind(this, CrudDialogMode.ACTIVATE)
      },
      {
        text: 'ייצוא פניות למשרה',
        icon: 'mdi-export',
        handler: this.exportJobApplications
      }
    ]
  }

  async exportJobApplications (jobListing: JobListing) {
    this.isLoading = true
    const jobApps = await fetchJobApplications(
      { jobListingId: jobListing.id },
      this.jwt
    )
    const data = jobApps.map((ja: JobApplication) => ({
      ...ja,
      age: getAge(ja.user?.birthday),
      area: ja.user?.closestArea?.name,
      authority: ja.user?.authority?.name,
      createdAtDate: new Date(ja.createdAt ?? '').toLocaleDateString('he-IL'),
      createdAtTime: new Date(ja.createdAt ?? '').toLocaleTimeString('he-IL'),
      firstName: ja.user?.firstName,
      jobListingAgeAtApplication: `${getDaysAndHoursBetweenDates(
        new Date(ja.jobListing?.airsAt || ''),
        new Date(ja.createdAt ?? '')
      ).days} ימים ו-${getDaysAndHoursBetweenDates(
        new Date(ja.jobListing?.airsAt || ''),
        new Date(ja.createdAt ?? '')
      ).hours} שעות`,
      lastName: ja.user?.lastName,
      phone: ja.user?.phone,
      type: ja.type === 'WHATSAPP' ? 'וואטסאפ' : 'טלפון',
      userCreatedAt: new Date(ja.user?.createdAt ?? '').toLocaleDateString('he-IL')
    }))
    downloadFile(
      'jobApplications.csv',
      convertToCsv(data, this.jobApplicationsByJobListingHeaders)
    )
    this.isLoading = false
  }

  async searchEmployers (searchText: string) {
    this.isEmployerSearchLoading = true
    this.searchTimeout = debounce(async () => {
      const newUsers = await fetchUsers(
        {
          limit: 10,
          searchText: searchText,
          isArchived: false,
          isApproved: true,
          roles: [Role.EMPLOYER]
        },
        this.jwt
      )
      this.users.length = 0
      newUsers.users.forEach((u) => this.users.push(u))
    }, this.searchTimeout)
    this.isEmployerSearchLoading = false
  }

  setContactMethods () {
    if (!this.currentJobListing.contactMethods) this.currentJobListing.contactMethods = []

    if (this.currentJobListing.phone) this.currentJobListing.contactMethods.push(JobListingContactMethod.PHONE_CALL)
    if (this.currentJobListing.whatsapp) this.currentJobListing.contactMethods.push(JobListingContactMethod.WHATSAPP_MSG)
    if (this.currentJobListing.isAcceptingInAppApplications) this.currentJobListing.contactMethods.push(JobListingContactMethod.JOB_APPLICATION)

    if (!this.currentJobListing.phone && this.currentJobListing.whatsapp) this.currentJobListing.phone = this.currentJobListing.whatsapp
  }

  setJobsAmount () {
    if (this.currentJobListing.jobsAmount) {
      if (this.currentJobListing.jobsAmount > 1 && this.currentJobListing.jobsAmount < 11) this.currentJobListing.jobsAmount = 5
      else if (this.currentJobListing.jobsAmount > 11 && this.currentJobListing.jobsAmount < 21) this.currentJobListing.jobsAmount = 15
      else if (this.currentJobListing.jobsAmount > 21 && this.currentJobListing.jobsAmount < 31) this.currentJobListing.jobsAmount = 25
      else if (this.currentJobListing.jobsAmount > 31) this.currentJobListing.jobsAmount = 35
    }
  }

  addressesRule (): boolean | string {
    const len = this.currentJobListing.addresses?.length || 0
    if (len === 0) return 'שדה חובה'

    if (len > 10) return 'יותר מדי כתובות. מותר עד 10'

    if (!this.isPremium() && len > 1) return 'יותר מדי כתובת. רק למשרות פרימיום יש ריבויי כתובות'
    return true
  }

  get formattedJobListings () {
    return this.jobListings.map((jl) => ({
      ...jl,
      minimumAge: jl.minimumAge ? jl.minimumAge : '',
      hourlyRate: this.rateBySalaryType(jl.salaryType, jl.hourlyRate),
      expiresAt:
        new Date(jl.expiresAt || '') > new Date() ? 'בתוקף' : 'לא בתוקף',
      daysToExpiry: Math.ceil(getDaysFromNow(new Date(jl.expiresAt || ''))),
      firstApplicationAt: jl.firstApplicationAt
        ? new Date(jl.firstApplicationAt).toLocaleDateString('he-IL')
        : '',
      ownerName:
        (jl.business?.owner?.firstName || '') +
        ' ' +
        (jl.business?.owner?.lastName || ''),
      airsAt: new Date(jl.airsAt).toLocaleDateString('he-IL'),
      airsAtTime: `${new Date(jl.airsAt)
        ?.getHours()
        .toString()
        .padStart(2, '0')}:${new Date(jl.airsAt)
        ?.getMinutes()
        .toString()
        .padStart(2, '0')}`,
      unmannedJobsAmount: safeSubtract(jl.jobsAmount, jl.jobsMannedAmount),
      activeAuthorityName: jl.authority?.name,
      activeAreaName: jl.area?.name,
      plan: translate(jl.plan)
    }))
  }

  get filters (): Filter<string>[] {
    return [
      {
        action: (filter) => {
          this.handleStringFilters(filter)
        },
        text: 'מסלול פרסום',
        type: FilterType.CHECKBOX,
        field: FilterField.planTypes,
        subItems: _.values(JobListingPlan).map((p) => ({
          text: translate(p),
          value: p,
          isSelected: !!this.planFilter?.includes(p)
        }))
      },
      {
        action: (filter) => {
          this.handleStringFilters(filter)
        },
        text: 'אזורי תעסוקה',
        type: FilterType.CHECKBOX,
        field: FilterField.areaIds,
        subItems:
          this.areas?.map((a: Area) => ({
            text: a.name || '',
            value: a.id || '',
            isSelected: !!this.closestAreaFilter?.idIn?.includes(a.id ?? '')
          })) || []
      },
      {
        action: (filter: Filter<string>) => {
          this.handleStringFilters(filter)
        },
        text: 'רשויות',
        type: FilterType.CHECKBOX,
        field: FilterField.authorityIds,
        subItems:
          this.authorities?.map((a) => ({
            text: a.name || '',
            value: a.id || '',
            isSelected: !!this.authorityFilter?.idIn?.includes(a.id ?? '')
          })) || []
      }
    ]
  }

  isExpires (expiresAt: Date): boolean {
    return new Date(expiresAt) < new Date()
  }

  isAired (airsAt: Date): boolean {
    return new Date(airsAt) <= new Date()
  }

  determineJobListingStatus (jl) {
    if (!this.isExpires(jl.expiresAt) && this.isAired(jl.airsAt) && !jl.isBlocked) {
      jl.status = 'פעילה'
    } else if (this.isExpires(jl.expiresAt) && this.isAired(jl.airsAt) && !jl.isBlocked) {
      jl.status = 'פג תוקף'
    } else if (!this.isExpires(jl.expiresAt) && !this.isAired(jl.airsAt) && !jl.isBlocked) {
      jl.status = 'לא עלתה לאוויר'
    } else if (jl.isBlocked) {
      jl.status = 'חסומה'
    } else if (jl.business.isApproved === null) {
      jl.status = 'בהמתנה לאישור'
    } else if (jl.reports?.length > 0) {
      jl.status = 'מדווחת'
    } else {
      jl.status = 'לא ידוע'
    }
  }

  async exportJobListings () {
    this.isLoading = true
    const headers = [
      { text: 'מזהה משרה', value: 'id' },
      { text: 'תפקיד', value: 'name' },
      { text: 'מקום עבודה', value: 'workplace' },
      { text: 'מזהה המעסיק של המשרה', value: 'business.owner.id' },
      { text: 'שם פרטי מפרסם המשרה', value: 'business.owner.firstName' },
      { text: 'שם משפחה מפרסם המשרה', value: 'business.owner.lastName' },
      { text: 'מייל מפרסם המשרה', value: 'business.owner.email' },
      { text: 'טלפון מפרסם המשרה ', value: 'phone' },
      { text: 'וואטסאפ מפרסם המשרה ', value: 'whatsapp' },
      { text: 'תאריך עלייה לאוויר', value: 'airsAt' },
      { text: 'תאריך ירידה מפרסום', value: 'expiresAt' },
      { text: 'מסלול פרסום', value: 'plan' },
      { text: 'כתובות', value: 'addresses' },
      { text: 'סטטוס', value: 'status' },
      { text: 'גיל', value: 'minimumAge' },
      { text: 'סדר גודל', value: 'jobsAmount' },
      { text: 'שכר שעתי', value: 'hourlyRate' },
      { text: 'תחום', value: 'branch.name' },
      { text: 'דיווחים', value: 'reports.length' },
      { text: 'פניה לראשונה', value: 'firstApplicationAt' },
      { text: 'סה"כ פניות', value: 'totalApplications' },
      { text: 'סה"כ פניות בוואטסאפ', value: 'totalWhatsappApplications' },
      { text: 'סה"כ פניות בטלפון', value: 'totalPhoneApplications' },
      { text: 'פניות ייחודיות', value: 'uniqueApplications' },
      { text: 'אזור תעסוקה', value: 'area.name' },
      { text: 'רשות', value: 'authority.name' }
    ]
    const result: JobListing[] = []
    for (let page = 0; page * this.itemsPerPage < this.totalJobListings; page++) {
      const payload = this.buildFetchJobListingsPayload(
        page + 1,
        this.$route.query.searchText as string
      )
      const { jobListings } = await makeGqlRequest(
        getJobListings,
        payload,
        this.jwt
      )
      for (const jl of jobListings.jobListings) {
        this.determineJobListingStatus(jl)
      }
      result.push(...jobListings.jobListings)
    }
    const csv = convertToCsv(result, headers)
    downloadFile('JobListings.csv', csv)
    this.isLoading = false
  }
}
